import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/presentation/SimplePresentationRunner";
import {HOTB} from "../../HOTB";
import {ExtendedGameMode} from "../../server/ExtendedGameMode";
import {gsap} from "gsap";
import {HOTBGameData} from "../../server/HOTBData";

export class PickClickResetPresentation implements SimplePresentation {
    private _mainTl: gsap.core.Timeline;

    shouldRun(): boolean {
        const gameData: HOTBGameData = HOTB.model.gameData;

        let flag: boolean = false;

        if(gameData.mode === ExtendedGameMode.CAPWIN_GAME) {
            flag = true;
        }

        return flag;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._mainTl = gsap.timeline({
            delay: 0.2,
            onComplete: (): void => {
                this._mainTl.kill();
                controller.finish();
            }
        });

        this._mainTl.add(HOTB.pickAndClickView.resetPickClick());
    };
}